import { render, staticRenderFns } from "./FolImportacaoFuncionarioPrincipal.vue?vue&type=template&id=6bc932e1&"
import script from "./FolImportacaoFuncionarioPrincipal.vue?vue&type=script&lang=js&"
export * from "./FolImportacaoFuncionarioPrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports